var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TikTok - Negative",
    clipPath: "url(#clip0_901_3661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.82474 0H5.97092V7.49274C5.97092 8.38551 5.25792 9.11885 4.37062 9.11885C3.48332 9.11885 2.77032 8.38551 2.77032 7.49274C2.77032 6.61595 3.46748 5.89854 4.3231 5.86667V3.98551C2.43758 4.01738 0.916504 5.56377 0.916504 7.49274C0.916504 9.43769 2.46927 11 4.38648 11C6.30365 11 7.85642 9.42174 7.85642 7.49274V3.65072C8.55359 4.16087 9.40918 4.46377 10.3123 4.47972V2.59855C8.91803 2.55073 7.82474 1.4029 7.82474 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_3661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokwhite);
export default __webpack_public_path__ + "static/media/tiktokwhite.0d400b388f663868340733dbbcd97c26.svg";
export { ForwardRef as ReactComponent };